export default "__VITE_ASSET__185fda56__"